import { render } from "./draftSummary.vue?vue&type=template&id=1befcc6f"
import script from "./draftSummary.vue?vue&type=script&lang=js"
export * from "./draftSummary.vue?vue&type=script&lang=js"

import "./draftSummary.vue?vue&type=style&index=0&id=1befcc6f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__